const SDK_VERSION = '7.120.2';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
